import { Button } from './ui/button';
import { User, Package, MapPin, LogOut, Phone, Mail } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

import { Sheet, SheetContent } from './ui/sheet';
import { Separator } from './ui/separator';

interface UserMenuDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UserMenuDrawer = ({ open, onOpenChange }: UserMenuDrawerProps) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 p-0 flex flex-col h-full">
        <div className="flex flex-col h-full">
          {/* User Info Section */}
          <div className="p-4 border-b">
            {user && (
              <div>
                <div className="font-semibold text-base mb-1">{user.first_name} {user.last_name}</div>
                {user.email && <div className="text-sm text-muted-foreground break-all">{user.email}</div>}
                {user.phone && <div className="text-sm text-muted-foreground">+91 {user.phone}</div>}
              </div>
            )}
          </div>

          {/* Menu Items - Scrollable */}
          <div className="flex flex-col gap-1 p-2 flex-1 overflow-y-auto">
            <Button 
              variant="ghost" 
              className="justify-start w-full" 
              onClick={() => {
                navigate('/profile');
                onOpenChange(false);
              }}
            >
              <User className="mr-2 h-5 w-5" /> Profile
            </Button>
            <Button 
              variant="ghost" 
              className="justify-start w-full" 
              onClick={() => {
                navigate('/orders');
                onOpenChange(false);
              }}
            >
              <Package className="mr-2 h-5 w-5" /> My Orders
            </Button>
            <Button 
              variant="ghost" 
              className="justify-start w-full" 
              onClick={() => {
                navigate('/addresses');
                onOpenChange(false);
              }}
            >
              <MapPin className="mr-2 h-5 w-5" /> My Addresses
            </Button>
          </div>

          {/* Contact Us Section - Fixed at bottom */}
          <div className="border-t p-4 bg-background">
            <h4 className="font-semibold text-sm mb-3 text-foreground">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="flex-shrink-0 mt-0.5 h-4 w-4 text-muted-foreground" />
                <span className="text-sm text-muted-foreground">Hyderabad, Telangana, India</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="flex-shrink-0 h-4 w-4 text-muted-foreground" />
                <a href="mailto:hello@indispare.com" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  hello@indispare.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="flex-shrink-0 h-4 w-4 text-muted-foreground" />
                <a href="tel:+919876543210" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  +91 9876543210
                </a>
              </div>
            </div>
          </div>

          {/* Logout Button - Fixed at very bottom */}
          <div className="border-t p-4 bg-background">
            <Button variant="destructive" className="w-full" onClick={logout}>
              <LogOut className="mr-2 h-5 w-5" /> Logout
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
